import styled from '@emotion/styled'
import { DEFAULT_THEME_COLORS, DEFAULT_FONT_STYLES } from 'css/theme'
import { getCurrencySymbol } from 'utils/functions/currencyUtils'
import { getFrequencyString } from 'utils/functions/frequencyUtils'
import { Frequency } from '@classy/campaign-page-blocks'
import { getCurrencyDecimalPlaces } from 'utils/currency'

const AmountSection = styled.div({
  color: DEFAULT_THEME_COLORS['--theme-color--neutral-20'],
  display: 'inline',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
})

const FlexColumn = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
})

const Amount = ({
  amount,
  currency,
  locale,
}: {
  amount?: number
  currency: string
  locale?: string
}) => {
  // Format amount to add commas for thousands and two fraction digits
  const formattedAmount = amount?.toLocaleString(locale, {
    minimumFractionDigits: getCurrencyDecimalPlaces(currency),
    maximumFractionDigits: getCurrencyDecimalPlaces(currency),
  })

  return (
    <span>
      <sup style={{ fontSize: DEFAULT_FONT_STYLES['--theme-font--title-page-sm__font-size'] }}>
        {getCurrencySymbol(currency)}
      </sup>
      <span style={{ fontSize: '36px' }}>{formattedAmount}</span>
    </span>
  )
}

const Currency = ({ currency }: { currency: string }) => {
  return (
    <span style={{ textAlign: 'left', color: DEFAULT_THEME_COLORS['--theme-color--neutral-40'] }}>
      {currency.toUpperCase()}
    </span>
  )
}

const FrequencySection = ({ frequency }: { frequency: Frequency }) => {
  return (
    <span style={{ textAlign: 'left', fontWeight: '500' }}>
      {getFrequencyString(frequency).toLowerCase()}
    </span>
  )
}

const AmountCurrencyFrequencySection = ({
  amount,
  currency,
  frequency,
  locale,
}: {
  amount?: number
  currency: string
  frequency: Frequency
  locale: string
}) => {
  return (
    <AmountSection>
      <span style={{ display: 'flex', justifyContent: 'center' }}>
        <Amount amount={amount} currency={currency} locale={locale} />
        <FlexColumn style={{ paddingLeft: '4px' }}>
          <FlexColumn style={{ lineHeight: '14px' }}>
            <Currency currency={currency}></Currency>
            <FrequencySection frequency={frequency}></FrequencySection>
          </FlexColumn>
        </FlexColumn>
      </span>
    </AmountSection>
  )
}

export default AmountCurrencyFrequencySection
